import styles from "./cart.module.css";
import x1 from "../../../assets/images/axnew1.png";
import { BiTrash } from "react-icons/bi";
import { BsPlus } from "react-icons/bs";
import { HiMinusSm, HiTrash } from "react-icons/hi";
import pic from "assets/images/cover2.png";
import ShoppingCart from "./ShoppingCart";
import { addCommas } from "@persian-tools/persian-tools";
import { connection } from "utils/apiConnection.ts";
import ShoppingBasketDefault from "assets/images/shoppingBasketDefault.png";

import { RiArrowDownSFill } from "react-icons/ri";
import toast from "react-hot-toast";
const Acordion = ({
  typeee,
  index,
  data,
  updateShoppingList,
  length,
  setIsLoading
}) => {
  const toggleAccordion = () => {
    const el = document.querySelector(`#accordion-${index}`);
    if (el.classList.contains("show")) {
      el.classList.replace("show", "collapsed");
    } else {
      el.classList.add("show");
    }
  };
  const discountSection = (totalPrice, salePrice, count) => {
    let element;
    salePrice == "0"
      ? (element = (
          <div className="">
            <div className={styles.bdiSt}>
              {" "}
              قیمت
              {addCommas(totalPrice * count)} تومان
            </div>
          </div>
        ))
      : (element = (
          <div className="d-flex align-items-center  justify-content-center">
            <div className=" align-items-center  mx-2">
              <div className="d-flex justify-content-center">
                {/* <p className={styles.offSt2}>
                  {Math.floor((salePrice / totalPrice) * 100)} %
                </p> */}
                <p className={styles.priceSt}>
                  {" "}
                  قیمت
                  {addCommas(totalPrice * count)} تومان
                </p>
              </div>

              <p className={`text-danger ${styles.finalPrice}`}>
                قیمت نهایی
                {addCommas((totalPrice - salePrice) * count)}
                <bdi className={styles.bdiSt}>تومان</bdi>
              </p>
            </div>
          </div>
        ));

    return element;
  };
  const addCartItem = (type, id, count, price, max, currentCount) => {
    setIsLoading(true);
    let temp = { count: count };
    if (type == "basket") {
      temp = { ...temp, basketId: id };
    } else if (type == "product") {
      temp = { ...temp, productForOrderId: id, price: price };
    }
    if (type == "basket" && currentCount == max) {
      toast.error(`حداکثر تعداد سفارش این سبد ${max} می باشد.`);
      setIsLoading(false);
    } else {
      connection("api/addcartitem", temp).then(data => {
        if (data.status == 1) {
          updateShoppingList();
          // setIsLoading(false);
        } else {
          toast.error("متاسفانه مشکلی در افزودن سبد پیش امده است.");
          setIsLoading(false);
        }
      });
    }
  };
  const reduceCartItem = (type, id) => {
    setIsLoading(true);
    let temp = {};
    if (type == "basket") {
      temp = { ...temp, basketId: id };
    } else if (type == "product") {
      temp = { ...temp, productForOrderId: id };
    }
    connection("api/reducecartitems", temp).then(data => {
      if (data.status == 1) {
        // setIsLoading(false);
        updateShoppingList();
      } else {
        toast.error("متاسفانه مشکلی در کاهش سبد پیش آمده است.");
        setIsLoading(false);
      }
    });
  };

  // console.log("items", data.items);
  // console.log("data accordion", data);
  return (
    <>
      <div
        // style={{ borderBottom: "0.5px dashed rgb(241, 234, 229)" }}
        className="py-2 px-3 "
      >
        <div
          className=" mb-3"
          style={{
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
            // backgroundColor: "rgb(241, 234, 229)",
            borderRadius: "10px"
          }}
        >
          <div
            className="px-3 pt-2 pb-2   text-dark "
            // style={{ backgroundColor: "#ddd" }}
          >
            <div className="d-flex  flex-wrap align-items-center justify-content-between pt-3">
              <div className="d-flex align-items-center col-12 col-sm-8 col-md-6 col-xl-6">
                {" "}
                <img
                  className={`ms-1 ${styles.imgSt}`}
                  // src={ShoppingBasketDefault}
                  src={
                    data.basket_info?.path != null
                      ? `http://sabadi.tatdemo.ir/${data.basket_info.path}`
                      : `http://sabadi.tatdemo.ir/${data.items &&
                          data.items[0]?.path}`
                  }
                />
                <div>
                  {" "}
                  <p className={`ms-4 ${styles.titleHead}`}>
                    <span className={`fw-bold fs-6 ${styles.oneLine}`}>
                      {data.basket_info?.title}
                    </span>{" "}
                  </p>{" "}
                  {/* <div
                  className={`d-flex align-items-baseline ps-2  mx-auto ${styles.storeName}`}
                  style={{ width: "200px" }}
                >
                  <div>
                    <img
                      className="shadow"
                      src={`http://sabadi.tatdemo.ir/${data.supplier_info.path}`}
                      style={{ width: "30px", height: 30, borderRadius: "50%" }}
                    />
                  </div>
                  <p className="ms-2" style={{ fontSize: "14px" }}>
                    {data.supplier_info.title}
                  </p>
                </div> */}
                </div>
              </div>
              <div className="col-12 col-sm-4 col-md-2 col-xl-2   ">
                {typeee != "0" && (
                  <div
                    className={`fw-bold ${styles.divbtt} d-flex align-items-center justify-content-evenly border rounded-pill mx-auto `}
                  >
                    <div>
                      <button
                        // className={`bg-danger ${styles.btn} ${styles.inc}`}
                        className={`btn text-center ${styles.noneShadow}`}
                        // onClick={onInc}
                        style={{ width: "30%" }}
                      >
                        <BsPlus
                          className={styles.trashbtn}
                          onClick={() => {
                            addCartItem(
                              "basket",
                              data?.rto_basket_id,
                              1,
                              "",
                              data?.basket_info.max_avb_in_order,
                              data?.current_count
                            );
                          }}
                        />
                      </button>
                    </div>

                    <span
                      style={{ width: "30%" }}
                      className={`text-center ${styles.quant}`}
                    >
                      {data?.current_count}
                    </span>
                    <div>
                      <button
                        // className={`${styles.btn} ${styles.remove}`}
                        // onClick={onDecrease}
                        className={`btn ${styles.noneShadow}`}
                        style={{ width: "30%" }}
                      >
                        {data?.current_count == "1" ? (
                          <HiTrash
                            className={styles.trashbtn}
                            onClick={() => {
                              reduceCartItem("basket", data?.rto_basket_id);
                            }}
                          />
                        ) : (
                          <HiMinusSm
                            className={styles.trashbtn}
                            onClick={() => {
                              reduceCartItem("basket", data?.rto_basket_id);
                            }}
                          />
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div
                className={`${typeee != 0 &&
                  "d-none"} col-12 col-sm-4 col-md-2 col-xl-2  text-center`}
              >
                {" "}
                {data?.current_count}عدد
              </div>
              <div
                className={`${typeee != 0 &&
                  "d-none"}  col-12 col-sm-6 col-xl-4 text-center`}
              >
                {discountSection(
                  data?.total_price,
                  data?.discount,
                  data?.current_count
                )}
              </div>
              <div
                className={`${typeee == "0" &&
                  "d-none"} col-12 col-md-4 col-xl-4 text-center`}
              >
                {" "}
                {discountSection(
                  data?.total_price,

                  data?.discount,
                  data?.current_count
                )}
              </div>
            </div>
          </div>
          <div className="d-flex flex-column justify-content-end ms-auto">
            <div className="d-flex  justify-content-end">
              <button
                className={`btn text-dark ${styles.btnacardeon}`}
                type="button"
                onClick={toggleAccordion}
              >
                <RiArrowDownSFill />
              </button>
            </div>
          </div>
          <div
            className="collapse "
            id={`accordion-${index}`}
            style={{ backgroundColor: "rgb(246 241 238)" }}
          >
            <div className="px-3 pb-2 my-2 py-1 d-flex flex-wrap">
              {data.items?.map((value, index) => (
                // <ShoppingCart type={0} data={value} />
                <div>
                  {value.product_title}&nbsp;{addCommas(value.price)} تومان(
                  {value.count} عدد)
                  {index != data.items?.length - 1 && ","}&nbsp;
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div
        className=" mx-5 pb-3"
        style={
          index == length - 1
            ? { borderBottom: "none" }
            : { borderBottom: "0.5px solid #ccc" }
        }
      ></div>
    </>
  );
};

export default Acordion;
